/**
 * Custom Sticky Header via GSAP & ScrollTrigger
 * Optimized to prevent load flashes for soundmagicheadphones.com
 */
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  
  gsap.registerPlugin(ScrollTrigger);

  const header = document.querySelector('.section-header');
  const headerWrapper = document.querySelector('.header-wrapper');
  
  if (!header || !headerWrapper) return;

  let isHidden = false;

  ScrollTrigger.create({
    start: "top -80", // Activates after scrolling down 80px
    onUpdate: (self) => {
      // 1. SCROLLING DOWN: Slide header up out of view
      if (self.direction === 1 && !isHidden) {
        gsap.to(header, { yPercent: -100, duration: 0.35, ease: "power2.out" });
        isHidden = true;
      } 
      // 2. SCROLLING UP: Slide header down and inject the solid background class
      else if (self.direction === -1 && isHidden) {
        headerWrapper.classList.add('is-solid');
        gsap.to(header, { yPercent: 0, duration: 0.35, ease: "power2.out" });
        isHidden = false;
      }
      
      // 3. AT THE VERY TOP: Strip the solid background class away
      if (self.progress === 0) {
        headerWrapper.classList.remove('is-solid');
      }
    }
  });
});